import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEmbeddedEffect } from '@machinemetrics/mm-react-embeddable';
import i18n from 'i18next';

import { actionCloseShiftIntro } from 'lib/actions';
import { getShiftIntroOpen } from 'lib/selectors/getShiftIntroOpen';
import { getShiftIntroSource } from 'lib/selectors/getShiftIntroSource';
import { SHIFT_HANDOVER_HOST } from 'lib/appConfig';
import { getCurrentOperator } from 'lib/selectors/getCurrentOperator';
import { getLatestOperator } from 'lib/selectors/getLatestOperator';
import { getMachine } from 'lib/selectors/getMachine';
import Routes from 'lib/utils/routes';
import MMEmbeddableZoneWithLoader from 'components/MMEmbeddableZoneWithLoader';
import MMDrawer from 'components/MMDrawer';
import { useTranslation } from 'react-i18next';

const EmbeddedShiftIntro = ({ id, operator }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const machine = useSelector(getMachine);
  const shiftIntroSource = useSelector(getShiftIntroSource);
  const [path, setPath] = useState('/intro');

  useEmbeddedEffect(id, 'shift-intro:close', () => {
    dispatch(actionCloseShiftIntro());
    // Navigate to select job after closing intro, but only on the sign-in
    // path -- an operator who opened the intro from the utility menu mid-shift
    // should land back where they were.
    if (shiftIntroSource === 'sign-in' && machine?.id) {
      history.push(Routes.machineIdSelectJobPath(machine.id));
    }
  });

  useEmbeddedEffect(id, 'shift-intro:setPath', (data) => {
    if (data?.path) {
      setPath(data.path);
    }
  });

  const context = {
    operatorId: operator?.id,
    operatorErpId: operator?.erpId,
    operatorName: operator?.name,
  };

  return (
    <MMEmbeddableZoneWithLoader
      id={id}
      src={`${SHIFT_HANDOVER_HOST}`}
      path={path}
      context={context}
      params={{
        language: i18n.language,
      }}
    />
  );
};

export const ShiftIntroWrapper = () => {
  const { t } = useTranslation();
  const id = 'shift-intro-screen';
  const dispatch = useDispatch();
  const shiftIntroOpen = useSelector(getShiftIntroOpen);
  const currentOperator = useSelector(getCurrentOperator);
  const latestOperator = useSelector(getLatestOperator);

  // The intro can also be opened from the utility menu with no active run, and
  // every handover screen needs an operatorId, so fall back to the last
  // operator on this machine.
  const introOperator = currentOperator ?? latestOperator;
  const operatorName = introOperator?.name;

  const operator = {
    id: introOperator?.id,
    erpId: introOperator?.erpId,
    name: operatorName,
  };

  return (
    <MMDrawer
      isOpen={shiftIntroOpen}
      onClose={() => {
        dispatch(actionCloseShiftIntro());
      }}
      title={
        operatorName
          ? t('hello, {{name}}', { name: operatorName })
          : t('hello operator')
      }
    >
      <EmbeddedShiftIntro id={id} operator={operator} />
    </MMDrawer>
  );
};
